// http://css-tricks.com/snippets/javascript/get-url-variables/
function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');

  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');

    if (pair[0] === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  return (false);
}

export default getQueryVariable;
